<template>

    <div>
        <div class="form" v-show="!globalLoading">


              <div v-if="includesSubscription === true && parentHasSubscription === false">
                <SubscriptionPayments
                        :stripe-public-key="stripePublicKey"
                        :stripe-account-id="stripeAccountId"
                        :orderId="orderId"
                        :payment-request-options="paymentRequestOptions"
                        @emit-global-loading="globalLoadingHandler"
                        :subdomain="subdomain"

                />
            </div>
            <div v-else>

              <ParentSubscriptionDetailsOnPaymentForm :plan="plan" v-if="parentHasSubscription === true"  />
                <OneOffPayments
                        :stripe-public-key="stripePublicKey"
                        :stripe-account-id="stripeAccountId"
                        :orderId="orderId"
                        :payment-request-options="paymentRequestOptions"
                        @emit-global-loading="globalLoadingHandler"
                        :parent-has-subscription="parentHasSubscription"
                        :subdomain="subdomain"
                />
            </div>
            <AgreeBeforeBooking />

        </div>
        <div v-show="globalLoading" class="fa-10x" style="text-align: center;">
            <PaymentsLoadingState/>
        </div>
    </div>

</template>

<script>
import OneOffPayments from './OneOff/OneOffPayments';
import SubscriptionPayments from './Subscriptions/SubscriptionPayments';
import PaymentsLoadingState from './PaymentsLoadingState';
import ParentSubscriptionDetailsOnPaymentForm from './Subscriptions/ParentSubscriptionDetailsOnPaymentForm';
import AgreeBeforeBooking from './Policies/AgreeBeforeBooking';

export default {
  name: 'SCAPayments',
  data() {
    return {
      globalLoading: false,
      stripeAccountId: '',
      stripePublicKey: '',
      orderId: null,
      paymentRequest: false,
      paymentRequestOptions: {
        country: null,
        currency: null,
        total: {
          label: null,
          amount: null,
        },
        displayItems: {},
      },
      includesSubscription: false,
      parentHasSubscription: false,
      plan: {
        name: '',
        cost: 0,
        frequency: '',
      },
      subdomain: 'your-club-name',
    };
  },

  methods: {
    createPaymentRequestOptions(optionsString) {
      return JSON.parse(optionsString);
    },
    globalLoadingHandler(e) {
      this.globalLoading = e;
    },
  },

  created() {
    this.stripeAccountId = this.$root.$el.dataset.clientStripeConnectAccount;
    this.stripePublicKey = this.$root.$el.dataset.stripePublicKey;
    this.orderId = this.$root.$el.dataset.orderId;
    this.paymentRequestOptions = this.createPaymentRequestOptions(this.$root.$el.dataset.paymentRequestOptions);
    this.includesSubscription = (this.$root.$el.dataset.includesSubscription === '1');
    this.parentHasSubscription = (this.$root.$el.dataset.parentHasSubscription === '1');

    this.plan.name = this.$root.$el.dataset.parentSubscriptionName;
    this.plan.cost = this.$root.$el.dataset.parentSubscriptionCost;
    this.plan.frequency = this.$root.$el.dataset.parentSubscriptionFrequency;

    this.subdomain = this.$root.$el.dataset.clientSubdomain;
  },

  components: {
    AgreeBeforeBooking,
    SubscriptionPayments,
    OneOffPayments,
    PaymentsLoadingState,
    ParentSubscriptionDetailsOnPaymentForm,
  },
};
</script>

<style lang="scss">
.form {
  background-color: #f6f9fc;
  padding: 12px;
  padding-top: 24px;
}

.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;

  &:before {
    content: '';
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }

  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 .5em;
    line-height: 1.5em;
    // this is really the only tricky part, you need to specify the background color of the container element...
    color: #2a2a2a;
    background-color: #fcfcfa;
  }

}

#card-element.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

#card-element.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

#card-element.StripeElement--invalid {
  border-color: #fa755a;
}

#card-element.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.pull-right {
  float: right !important;
}

ul.accordion {
  margin-left: 0;
}

.group {
  background: white;
  box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10),
  0 3px 6px 0 rgba(0,0,0,0.08);
  border-radius: 4px;
  /*margin-bottom: 20px;*/
}

.card-label {
  position: relative;
  color: #8898AA;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
}

.group .card-label:not(:last-child) {
  border-bottom: 1px solid #F0F5FA;
}

.card-label > span {
  width: 40px;
  text-align: left;
  margin-right: 20px;
}

#name-input {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  outline: none !important;
  border-style: none !important;
  width: 100%;
  padding: 12px 16px 12px 12px;
  background-color: transparent;
  -webkit-animation: 1ms void-animation-out;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  font-size: 16px;
  color: #32325d;
  -webkit-font-smoothing: antialiased;

}

#name-label {
  position: relative;
  color: #8898AA;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  display: flex;
  flex-direction: row;
}

#name-input::-webkit-input-placeholder {
  color: #aab7c4;
}

#name-input::-moz-placeholder {
  color: #aab7c4;
}

#name-input:-ms-input-placeholder {
  color: #aab7c4;
}

.field {
  background: transparent;
  font-weight: 300;
  border: 0;
  color: #31325F;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
}

</style>
